module.exports = __webpack_public_path__ + "img/truck-outline-black.23f03b3b.svg";